import React from 'react';

import {
  FormField,
  SectionCard,
  SelectInput,
  TextInput,
} from '../../../shared/components';

import {IBankingSubStepProps} from '../companyDetails.types';

const BankingSubStep: React.FC<IBankingSubStepProps> = ({
  bankNameOptions,
  accountTypeOptions,
  bankInputs,
  onBankInputChange,
}) => (
  <SectionCard className="company-card" title="Banking details">
    <div className="company-banking-grid">
      <FormField label="Bank name">
        {bankNameOptions.length > 0 ? (
          <SelectInput
            value={bankInputs.bankName}
            onChange={(event) =>
              onBankInputChange('bankName', event.target.value)
            }
            placeholder="Select a bank"
            options={bankNameOptions.map((option) => ({
              label: option.label,
              value: option.value,
            }))}
          />
        ) : (
          <TextInput
            type="text"
            value={bankInputs.bankName}
            onChange={(event) =>
              onBankInputChange('bankName', event.target.value)
            }
            placeholder="Enter bank name"
          />
        )}
      </FormField>

      <FormField label="Branch code">
        <TextInput
          type="text"
          value={bankInputs.branchCode}
          onChange={(event) =>
            onBankInputChange('branchCode', event.target.value)
          }
          placeholder="Enter branch code"
        />
      </FormField>

      <FormField label="Account type">
        {accountTypeOptions.length > 0 ? (
          <SelectInput
            value={bankInputs.accountType}
            onChange={(event) =>
              onBankInputChange('accountType', event.target.value)
            }
            placeholder="Select account type"
            options={accountTypeOptions.map((option) => ({
              label: option.label,
              value: option.value,
            }))}
          />
        ) : (
          <TextInput
            type="text"
            value={bankInputs.accountType}
            onChange={(event) =>
              onBankInputChange('accountType', event.target.value)
            }
            placeholder="Enter account type"
          />
        )}
      </FormField>

      <FormField label="Account number">
        <TextInput
          type="text"
          value={bankInputs.accountNumber}
          onChange={(event) =>
            onBankInputChange('accountNumber', event.target.value)
          }
          placeholder="Enter account number"
        />
      </FormField>
    </div>
  </SectionCard>
);

export default BankingSubStep;

export {BankingSubStep};
